import { useContext } from 'react';
import { DropdownContext } from './CustomDropdown';
import styles from './Dropdown.module.css';

export const CustomDropdownButton = ({ children, arrow = true, className = '' }) => {
    const { toggle } = useContext(DropdownContext);

    return (
        <button className={`${styles.button} ${className}`} onClick={toggle}>
            {children}
            {arrow && <span className={styles.arrow}>▼</span>}
        </button>
    );
};
